import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import { setLanguage } from '../helpers'

const languageBySubPathOrNavigator = setLanguage()
const timestamp = new Date().getTime()

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        lng: languageBySubPathOrNavigator,
        backend: {
            loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json?t=${timestamp}`,
        },
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    })

export default i18n
